<script>
  import { onDestroy, onMount } from "svelte";
  import ItemResponse from "./ItemResponse.svelte";
  import { currentSpec } from "../../editor/storage.js";
  import { Label, Input, Collapse } from "sveltestrap";

  export let inputFocusAction;
  export let inputBlurAction;
  export let label;
  export let labelValues;
  export let updateSplitHeader;
  export let updateLock;

  let newCustomValue, newCustomText;
  let showTextLine = label?.items?.map(() => true);
  onMount(() => {
    showTextLine = label === "new" ? undefined : label?.items?.map(() => true);
    newCustomValue = undefined;
    newCustomText = undefined;
  });
  onDestroy(() => {
    newCustomValue = undefined;
    newCustomText = undefined;
  });
  currentSpec.subscribe((spec) => {
    showTextLine =
      label === "new"
        ? undefined
        : label?.items?.map((_, i, arr) =>
            (i == 0 && arr.length == 1) || showTextLine?.[i] ? true : false
          );
    newCustomValue = undefined;
    newCustomText = undefined;
  });
</script>

{#if label}
  <div class="pane-divider" />
  <!-- Offset -->
  <div class="dupo-menu-pane mb-2">
    <ItemResponse
      type="width"
      title="Offset"
      token={`label-offset`}
      {inputFocusAction}
      {inputBlurAction}
      value={label?.offset}
      changeAction={(event) => {
        updateSplitHeader(event, `label.offset`, label);
      }}
    />
  </div>
  <div class="dupo-menu-pane mb-2">
    <div class="dupo-menu-pane-row">
      <h3 class="h-sub">Text lines</h3>
    </div>
  </div>
  <!-- Formatting per Line-->
  {#if label?.items}
    {#each label?.items as text, ti}
      <div class="dupo-menu-pane">
        <div class="dupo-menu-pane-row">
          <div
            class="menu-second-level handle-collapse"
            on:click={() => {
              showTextLine[ti] = !showTextLine[ti];
            }}
          >
            <i
              class={`bi bi-caret-${
                showTextLine[ti] ? "down-fill" : "right"
              } me-1`}
            />Text line {ti + 1}
          </div>
        </div>
      </div>
      <Collapse isOpen={showTextLine[ti]}>
        <!-- Layout -->
        <div class="dupo-menu-pane mb-2">
          <div class="dupo-menu-pane-row">
            <h3 class="h-sub">Layout</h3>
          </div>
        </div>
        <!-- Width -->
        <div class="dupo-menu-pane mb-2">
          <ItemResponse
            type="width"
            title="Width"
            token={`label-items-${ti}-width`}
            {inputFocusAction}
            {inputBlurAction}
            value={text.width}
            changeAction={(event) => {
              updateSplitHeader(event, `label.items.${ti}.width`, label);
            }}
          />
        </div>
        <!-- Align -->
        <div class="dupo-menu-pane mb-2">
          <ItemResponse
            type="textAlign"
            title="Text align"
            token={`label-items-${ti}-align`}
            {inputFocusAction}
            {inputBlurAction}
            value={text.textAlign}
            changeAction={(event) => {
              updateSplitHeader(event, `label.items.${ti}.align`, label);
            }}
          />
        </div>

        <div class="pane-divider" />
        <!-- Font style -->
        <div class="dupo-menu-pane mb-2">
          <div class="dupo-menu-pane-row">
            <h3 class="h-sub">Font style</h3>
          </div>
        </div>
        <!-- Font size -->
        <div class="dupo-menu-pane mb-2">
          <ItemResponse
            type="fontSize"
            title="Font size"
            token={`label-items-${ti}-fontSize`}
            {inputFocusAction}
            {inputBlurAction}
            value={text.fontSize || 16}
            changeAction={(event) => {
              updateSplitHeader(event, `label.items.${ti}.fontSize`, label);
            }}
          />
        </div>
        <!-- Font weight -->
        <div class="dupo-menu-pane mb-2">
          <ItemResponse
            type="fontWeight"
            title="Font weight"
            token={`label-items-${ti}-fontWeight`}
            {inputFocusAction}
            {inputBlurAction}
            value={text.fontWeight}
            changeAction={(event) => {
              updateSplitHeader(event, `label.items.${ti}.fontWeight`, label);
            }}
          />
        </div>
        <!-- Color -->
        <div class="dupo-menu-pane mb-2">
          <ItemResponse
            type="color"
            title="Font color"
            token={`label-items-${ti}-color`}
            {inputFocusAction}
            {inputBlurAction}
            isMarkLabel={false}
            value={text.color || "rgba(0,0,0,0)"}
            changeAction={(event) => {
              updateSplitHeader(event, `label.items.${ti}.color`, label);
            }}
          />
        </div>
        <!-- Font Stroke Color -->
        <div class="dupo-menu-pane mb-2">
          <ItemResponse
            type="color"
            title="Font stroke color"
            token={`label-items-${ti}-fontStroke`}
            {inputFocusAction}
            {inputBlurAction}
            isMarkLabel={false}
            value={text.fontStroke || "rgba(0,0,0,0)"}
            changeAction={(event) => {
              updateSplitHeader(event, `label.items.${ti}.fontStroke`, label);
            }}
          />
        </div>
        <!-- Opacity -->
        <div class="dupo-menu-pane mb-2">
          <ItemResponse
            type="opacity"
            title="Font opacity"
            token={`label-items-${ti}-opacity`}
            {inputFocusAction}
            {inputBlurAction}
            isMarkLabel={true}
            value={text.opacity || 1}
            changeAction={(event) => {
              updateSplitHeader(event, `label.items.${ti}.opacity`, label);
            }}
          />
        </div>

        <div class="pane-divider" />
        <!-- Formatting -->
        <div class="dupo-menu-pane mb-2">
          <div class="dupo-menu-pane-row">
            <h3 class="h-sub">Text formatting</h3>
          </div>
        </div>

        <!-- Format -->
        <div class="dupo-menu-pane mb-2">
          <ItemResponse
            type="text"
            title="Format string"
            token={`label-items-${ti}-format`}
            {inputFocusAction}
            {inputBlurAction}
            value={text.format}
            changeAction={(event) => {
              updateSplitHeader(event, `label.items.${ti}.format`, label);
            }}
          />
        </div>
        <!-- Expression -->
        <div class="dupo-menu-pane mb-2">
          <ItemResponse
            type="data-expression"
            title="Expression"
            token={`label-items-${ti}-expression`}
            {inputFocusAction}
            {inputBlurAction}
            value={text.expression}
            field={label.field}
            values={text.values || label.values || []}
            changeAction={(event) => {
              updateSplitHeader(event, `label.items.${ti}.expression`, label);
            }}
          />
        </div>

        <!-- Content -->
        {#if labelValues == 1}
          <div class="dupo-menu-pane mb-2">
            <ItemResponse
              type="longText"
              title="Content (custom text)"
              token={`label-items-${ti}-content`}
              {inputFocusAction}
              {inputBlurAction}
              value={text.content || ""}
              changeAction={(event) => {
                updateSplitHeader(event, `label.items.${ti}.content`, label);
              }}
            />
          </div>
        {:else}
          <!-- Custom -->
          <div class="dupo-menu-pane mb-2">
            <div class="dupo-menu-pane-row">
              <Label for={"custom-" + ti}>Custom per value</Label>
            </div>

            {#if text.customList !== undefined}
              {#each text.customList as custom, ci}
                <div class="dupo-menu-pane-form-row d-flex">
                  <Label
                    for={"custom-" + ti + "-value-" + ci}
                    style="width: 43%;"
                    class="text-sm mb-0">Value {ci + 1}</Label
                  >
                  <Label
                    for={"custom-" + ti + "-text-" + ci}
                    style="width: 53%;"
                    class="text-sm mb-0">Text {ci + 1}</Label
                  >
                  <Label style="width: 4%;" class="text-sm mb-0">-</Label>
                </div>
                <div class="dupo-menu-pane-form-row mb-1 d-flex">
                  <div class="form-wrap">
                    <Input
                      id={"custom-" + ti + "-value-" + ci}
                      name={"custom-" + ti + "-value-" + ci}
                      type="text"
                      autocomplete="off"
                      class="custom-form-select"
                      style="width: 40%;"
                      on:focus={inputFocusAction}
                      on:blur={inputBlurAction}
                      bind:value={custom.value}
                      on:change={(event) => {
                        updateSplitHeader(
                          text.customList,
                          `label.items.${ti}.custom`,
                          label
                        );
                      }}
                    />
                    <Input
                      id={"custom-" + ti + "-text-" + ci}
                      name={"custom-" + ti + "-text-" + ci}
                      type="text"
                      autocomplete="off"
                      class="custom-form-select"
                      style="width: 50%;"
                      on:focus={inputFocusAction}
                      on:blur={inputBlurAction}
                      bind:value={custom.text}
                      on:change={(event) => {
                        updateSplitHeader(
                          text.customList,
                          `label.items.${ti}.custom`,
                          label
                        );
                      }}
                    />
                    <button
                      type="button"
                      class="custom-form-select"
                      style="width: 10%; padding-left: 0; padding-right: 0;"
                      on:click={(event) => {
                        text.customList.splice(ci, 1);
                        updateSplitHeader(
                          text.customList,
                          `label.items.${ti}.custom`,
                          label
                        );
                      }}
                      ><i
                        class="bi bi-trash-fill"
                        alt="delete this custom item"
                      /></button
                    >
                  </div>
                </div>
              {/each}
            {/if}
            <div class="dupo-menu-pane-form-row d-flex">
              <Label
                for={"custom-" + ti + "-value-new"}
                style="width: 43%;"
                class="text-sm mb-0">New value</Label
              >
              <Label
                for={"custom-" + ti + "-text-new"}
                style="width: 53%;"
                class="text-sm mb-0">New text</Label
              >
              <Label style="width: 4%;" class="text-sm mb-0">+</Label>
            </div>
            <div class="dupo-menu-pane-form-row mb-1 d-flex">
              <div class="form-wrap">
                <Input
                  id={"custom-" + ti + "-value-new"}
                  name={"custom-" + ti + "-value-new"}
                  type="text"
                  autocomplete="off"
                  class="custom-form-select"
                  style="width: 40%;"
                  on:focus={inputFocusAction}
                  on:blur={inputBlurAction}
                  bind:value={newCustomValue}
                />
                <Input
                  id={"custom-" + ti + "-text-new"}
                  name={"custom-" + ti + "-text-new"}
                  type="text"
                  autocomplete="off"
                  class="custom-form-select"
                  style="width: 50%;"
                  on:focus={inputFocusAction}
                  on:blur={inputBlurAction}
                  bind:value={newCustomText}
                />
                <button
                  type="button"
                  class="custom-form-select"
                  style="width: 10%; padding-left: 0; padding-right: 0;"
                  on:click={(event) => {
                    updateSplitHeader(
                      { newCustomValue, newCustomText },
                      `label.items.${ti}.custom`,
                      label
                    );
                    newCustomValue = undefined;
                    newCustomText = undefined;
                  }}
                  ><i
                    class="bi bi-plus-circle"
                    alt="add this custom item"
                  /></button
                >
              </div>
            </div>
          </div>
        {/if}
        <!-- todo: delete this line -->
        <div class="dupo-menu-pane mb-2">
          <div class="dupo-menu-pane-button-row">
            <button
              on:click={(event) =>
                updateSplitHeader("delete", `label.items.${ti}`, label)}
              ><i class="bi bi-eraser me-1" /> Delete this line</button
            >
          </div>
        </div>
      </Collapse>
    {/each}
  {/if}
  <!-- Add a new line -->
  <div class="dupo-menu-pane mb-2">
    <div class="dupo-menu-pane-button-row">
      <button
        on:click={(event) => {
          updateSplitHeader("duplicate", "label.items", label);
          showTextLine.push(true);
        }}><i class="bi bi-plus-circle me-1" /> Add a new text line</button
      >
    </div>
  </div>

  <!-- lock -->
  <div class="pane-divider" />
  <div class="dupo-menu-pane pt-2">
    <ItemResponse
      type="lock"
      tooltipMessage="Prevent suggesting responsive alternatives that make changes to this multiples headers. Element-Lock applies to its source or target design(s)."
      title="Lock this header design"
      token={"label-lock"}
      value={label.lock}
      {inputFocusAction}
      {inputBlurAction}
      changeAction={(event) => {
        updateLock(event, "multiples.header");
      }}
    />
  </div>
{/if}
